<template>
  <div class="involvement-card-header involvement-card-header--extended">
    <span class="card-header__title">
      {{$t('feed.audit.involvement.period')}}:
      <b>{{periodName}}</b>
    </span>
    <period-range :chart-name="chartName" reload="Age"/>
    <div class="extended-conf">
      <el-input
        :placeholder="$t('feed.audit.involvement.placeholder')"
        v-for="(age, index) in ages"
        :key="index"
        class="extended-conf__item"
        :value="age === '40-200' ? '40+' : age"
        @input="changeAge($event, index)"
      ></el-input>
      <el-button type="primary" @click="onSubmitAge">{{$t('feed.audit.involvement.button')}}</el-button>
    </div>
  </div>
</template>

<script>
  // components
  import PeriodRange from "../../../../../../../../components/auditPeriodRange/PeriodRange";
  // vuex
  import { mapGetters } from 'vuex';
  import { CHANGE_AGE, GET_AUDIT } from '../../../../../../../../store/actions/audit';

  export default {
    name: "InvolvementHeader",
    props: {
      chartName: {
        type: String
      },
    },
    computed: {
      ...mapGetters([
        'ages',
      ]),
      periodName() {
        return this.$store.getters.auditPeriodName(this.chartName, this.$i18n);
      }
    },
    methods: {
      changeAge(event, idx) {
        this.$store.dispatch(CHANGE_AGE, {val: event, idx});
      },
      onSubmitAge() {
        this.$store.dispatch(GET_AUDIT, {chart: "Involvement", thread: this.$route.params.threadId});
        this.$store.dispatch(GET_AUDIT, {chart: "Age", thread: this.$route.params.threadId});
      },
    },
    components: {
      PeriodRange
    }
  };
</script>

<style>
  @import "../../../../../../../../style/cardHeaderTitle.css";
  .involvement-card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }

  .extended-conf {
    display: flex;
    width: 100%;
    margin: 20px 0 10px 0;
  }

  .extended-conf__item {
    margin-right: 10px;
  }

  .extended-conf__item:last-child {
    margin-right: 0;
  }

  .involvement-card-header--extended {
    flex-wrap: wrap;
  }
</style>
